import React, { useEffect, useState, useMemo } from 'react'
import { Grid } from '@material-ui/core'
import { useDispatch } from 'react-redux'

import { getCategoryList } from '_/modules/service-orders/actions'

import Accordion from '../../index'

import MultiSelectedTree from '_/components/multi-selected-tree-view'
import DynamicTreeView from '_/components/treeview'

import useStyles from '../../styles'

const AddCategories = ({ isEditing, setValue, data }) => {
  const styles = useStyles()
  const dispatch = useDispatch()
  const [categoryList, setCategoryList] = useState()

  const parsedData = useMemo(() => data?.map(item => item?.id) || [], [data])
  const [selectCategories, setSelectCategories] = useState(parsedData)

  useEffect(() => {
    if (!categoryList) return

    const payload = selectCategories
      ?.map(item => {
        const id = typeof item === 'object' ? item?.id : item
        const category = categoryList.find(cat => cat.id === id)
        return category ? { id: category.id, name: category.name, icon: null } : null
      })
      .filter(Boolean)

    setValue(payload)
  }, [selectCategories, categoryList])

  useEffect(() => {
    dispatch(getCategoryList({})).then(res => setCategoryList(res))
  }, [])

  const handleSelectedItemsChange = selectedItems => {
    setSelectCategories(selectedItems)
  }

  return (
    <Accordion
      id="categorias-da-empresa-1"
      title="Categorias de manutenção"
      className={styles.containerAdd}
    >
      <Grid className={styles.userListAdd}>
        {!isEditing && data && <DynamicTreeView data={data} disabled />}
        {isEditing && (
          <MultiSelectedTree
            data={categoryList}
            categories={data}
            onSelectedItemsChange={handleSelectedItemsChange}
          />
        )}
      </Grid>
    </Accordion>
  )
}

export default AddCategories
